import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/one-tree-planted-banner.jpg")